module.exports = __webpack_public_path__ + "img/pic_chumanyi2.d8c43596.png";